export default function CenteredParagraph({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`text-center ${className}`}>{children}</div>;
}
